import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { PawPrint, LogIn } from 'lucide-react';
import PasswordInput from '../components/PasswordInput';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === 'string' ? d : 'Credenciais inválidas');
    } finally { setLoading(false); }
  };

  return (
    <div className="flex items-center justify-center min-h-[60vh]" data-testid="login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <PawPrint className="w-12 h-12 text-primary mx-auto mb-3" />
          <h1 className="font-heading font-black text-2xl text-foreground">Entrar no AnimaLog</h1>
          <p className="text-sm text-muted-foreground mt-1">Acesso para funcionários</p>
        </div>
        <form onSubmit={handleSubmit} className="bg-card rounded-2xl border border-border p-6 space-y-4" data-testid="login-form">
          {error && <div data-testid="login-error" className="bg-destructive/10 text-destructive text-sm p-3 rounded-xl">{error}</div>}
          <div>
            <label className="text-sm font-medium text-foreground block mb-1.5">Email</label>
            <input data-testid="login-email" type="email" value={email} onChange={e => setEmail(e.target.value)} required
              className="w-full rounded-xl border border-border bg-background px-3 py-2 text-sm focus:ring-2 focus:ring-primary focus:outline-none" placeholder="email@animalog.pt" />
          </div>
          <div>
            <label className="text-sm font-medium text-foreground block mb-1.5">Password</label>
            <PasswordInput value={password} onChange={e => setPassword(e.target.value)} required testid="login-password" placeholder="........" />
          </div>
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full bg-primary text-primary-foreground rounded-full py-2.5 text-sm font-medium hover:brightness-110 transition-all flex items-center justify-center gap-2 disabled:opacity-50">
            <LogIn className="w-4 h-4" />{loading ? 'A entrar...' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}
